import React, { useState } from "react";
import { useContext, useEffect } from "react";
import { supabase } from "./supabaseClient";
import Auth from "./Auth";
import { AuthContext } from "./AuthProvider";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Account from "./Account";
import { Feeds } from "./pages/Feeds/Feeds";
import { NewFeed } from "./pages/Feeds/NewFeed";
import { FeedDetail } from "./pages/Feeds/FeedDetail";
import { Planner } from "./pages/Planner/Planner";

import "./index.css";
import "./App.css";
import { AuthCallback } from "./pages/Auth";
import { SavedDescriptionsPage } from "./pages/SavedDescriptions";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Planner />,
    // errorElement: <ErrorPage />,
  },
  {
    path: "/feeds",
    element: <Feeds />,
  },
  {
    path: "/feeds/:feedId",
    element: <FeedDetail />,
  },
  {
    path: "/saved-descriptions",
    element: <SavedDescriptionsPage />,
  },
  {
    path: "/feeds/new",
    element: <NewFeed />,
  },
  {
    path: "/me",
    element: <Account />,
  },
  {
    path: "/auth/:provider/redirect",
    element: <AuthCallback />,
  },
]);

export default function App() {
  const [loading, setLoading] = useState(true);
  const { session, setSession } = useContext(AuthContext);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      console.log("App: Initial session", session);
      setSession?.(session);
      setLoading(false);
    });

    supabase.auth.onAuthStateChange((_event, session) => {
      setSession?.(session);
    });
  }, [setSession]);

  if (loading) {
    return null;
  }

  return (
    <div className="bg-base-300">
      {!session ? (
        <Auth />
      ) : (
        <>
          <RouterProvider router={router} />
        </>
      )}
    </div>
  );
}
